import React, { useMemo } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

type Props = {
    title?: string;
    periodLabel: string;                      // Ej: "Periodo: 2025-10-01 → 2025-10-31"
    completed?: number;                       // default 0
    failed?: number;                          // default 0
    loading?: boolean;
    error?: string | null;
    colors?: [string, string];                // [completadas, fallidas]
    height?: number;                          // px, default 280
    className?: string;                       // clases extra para el wrapper de tarjeta
};

const PickupDonutComponent: React.FC<Props> = ({
 title = "Recogidas completadas vs fallidas",
 periodLabel,
 completed = 0,
 failed = 0,
 loading = false,
 error = null,
 colors = ["#326e5a", "#c51b1b"],
 height = 280,
 className = "",
}) => {
    const donutData = useMemo(
        () => [
            { name: "Completadas", value: Number.isFinite(completed) ? completed : 0 },
            { name: "Fallidas", value: Number.isFinite(failed) ? failed : 0 },
        ],
        [completed, failed]
    );

    const noData = donutData[0].value === 0 && donutData[1].value === 0;

    return (
        <div className={`rounded-2xl border bg-white shadow-sm ${className}`}>
            <div className="p-4 flex items-center justify-between">
                <h3 className="font-semibold">{title}</h3>
                <div className="text-sm text-gray-600">{periodLabel}</div>
            </div>

            <div className="px-4 pb-6">
                {loading ? (
                    <div className="p-6 text-sm text-gray-500">Cargando estadísticas…</div>
                ) : error ? (
                    <div className="p-6 text-sm text-rose-600">{error}</div>
                ) : (
                    <div className="relative" style={{ height }}>
                        {/* Overlay “No hay datos…” */}
                        {noData && (
                            <div className="absolute inset-0 z-10 flex items-center justify-center">
                                <div className="rounded-xl bg-white/80 px-4 py-2 text-sm text-gray-700 shadow">
                                    No hay datos para el periodo seleccionado.
                                </div>
                            </div>
                        )}

                        {/* Gráfico (difuminado si no hay data) */}
                        <div className={noData ? "h-full opacity-40 blur-[2px] pointer-events-none" : "h-full"}>
                            <ResponsiveContainer width="100%" height="100%">
                                <PieChart>
                                    <Pie
                                        data={donutData}
                                        dataKey="value"
                                        nameKey="name"
                                        innerRadius={70}
                                        outerRadius={110}
                                        paddingAngle={2}
                                        cornerRadius={3}
                                    >
                                        {donutData.map((_, i) => (
                                            <Cell key={i} fill={colors[i % colors.length]} />
                                        ))}
                                    </Pie>
                                    <Tooltip formatter={(value: any, name: any) => [value, name]} />
                                    <Legend verticalAlign="bottom" height={24} />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export const PickupDonut = React.memo(PickupDonutComponent);
